import { useSelector, useDispatch } from 'react-redux';
import { selectIsSeonEnabled } from '~/components/brand/ducks/selectors.js';
import { seonVerification } from '../withdraw/api/client.js';
import { updateCredentials } from '~/components/authentication/ducks/index.js';
import { useEffect } from 'react';
import { useAppSelector } from '~/store/types';
import { selectdeviceSessionId } from '~/components/authentication/ducks/selectors.js';

const useSeonPayment = () => {
	const isSeonDeviceIdEnabled = useSelector(selectIsSeonEnabled);
	const deviceSession = useAppSelector(selectdeviceSessionId);
	const dispatch = useDispatch();

	const encryptedPlayerId = useSelector(state => state.account && state.account.id);

	useEffect(() => {
		if (deviceSession) {
			dispatch(updateCredentials({ deviceSession }));
		}
	}, [deviceSession, dispatch]);

	const addSeonEvent = async () => {
		try {
			if (isSeonDeviceIdEnabled && deviceSession !== '' && encryptedPlayerId) {
				await seonVerification({
					encryptedPlayerId,
					deviceSessionId: deviceSession
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	return { addSeonEvent };
};

export default useSeonPayment;
